var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAckodriveExpress = function SvgAckodriveExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M5 3.75H1.5M4.764 7.75H1M5.5 11.75H3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M9.236 2.16A.25.25 0 0 1 9.47 2h3.872c.178 0 .3.181.231.346l-1.426 3.447h2.303a.25.25 0 0 1 .189.414l-6.152 7.038c-.171.196-.491.033-.432-.221l1.11-4.754a.25.25 0 0 0-.243-.307H7.364a.25.25 0 0 1-.233-.34zm.83.965a.25.25 0 0 0-.234.163L8.627 6.55a.25.25 0 0 0 .235.336h1.284a.25.25 0 0 1 .241.316l-.68 2.48c-.071.259.262.432.434.225l2.303-2.778a.25.25 0 0 0-.192-.41h-1.534l1.292-3.252a.25.25 0 0 0-.232-.342z",
    clipRule: "evenodd"
  })));
};
export default SvgAckodriveExpress;